import { ISchemaError } from "../interfaces/ISchemaError/ISchemaError";
import { z } from "zod";

export const channelIdSchema = z.string({ invalid_type_error: ISchemaError.CHANNEL_ID_INVALID_TYPE }).min(1, { message: ISchemaError.NO_CHANNEL_ID });
